module.exports = __webpack_public_path__ + "static/media/ic_pay_googlepay.b7b38f9b.svg";